module.exports = __webpack_public_path__ + "assets/media/facebook-footer.0ea8b0b0.svg";